import React, { useEffect, useState } from 'react';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';
import { updateRequestStatus, TALEP_DURUMLARI } from '../../services/requestService';

const hataMesaji = (err, varsayilan) =>
  err?.response?.data?.message || err?.response?.data?.mesaj || err?.message || varsayilan;

/**
 * Yönetici durum değişikliği onayı. Yalnızca 'Tamamlandı' (çavuşa göndermeden kapatma; vatandaşa
 * bildirim gitmez) ve 'Yeni Talep' (yeniden açma; çavuş/personel ataması kaldırılır).
 */
const DurumDegistirModal = ({ isOpen, talep, yeniDurum, onClose, onSuccess }) => {
  const [aciklama, setAciklama] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState(null);

  useModalClose(isOpen, onClose);

  useEffect(() => {
    if (isOpen) {
      setAciklama('');
      setHata(null);
    }
  }, [isOpen]);

  if (!isOpen || !talep || !yeniDurum) return null;

  const kapatma = yeniDurum === TALEP_DURUMLARI.TAMAMLANDI;

  const onayla = async () => {
    setGonderiliyor(true);
    setHata(null);
    try {
      await updateRequestStatus({ id: talep.requestId, durum: yeniDurum, aciklama: aciklama.trim() || undefined });
      onSuccess();
    } catch (e) {
      setHata(hataMesaji(e, 'Durum güncellenemedi.'));
    } finally {
      setGonderiliyor(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="talep-akisi-modal talep-akisi-modal--dar" role="dialog" aria-modal="true" aria-labelledby="durum-baslik">
        <div className="talep-akisi-modal__header">
          <h3 id="durum-baslik">{kapatma ? 'Talebi Sonuçlandır' : 'Talebi Yeniden Aç'}</h3>
          <button type="button" className="talep-akisi-modal__kapat" onClick={onClose} aria-label="Kapat">×</button>
        </div>
        <div className="talep-akisi-modal__body">
          <p className="talep-akisi-modal__ozet">#{talep.requestId} · {talep.kategori} · {talep.adres}</p>
          <p>
            Durum <b>{talep.durum}</b> → <b>{yeniDurum}</b> olacak.
          </p>
          <p className="talep-akisi-modal__uyari">
            {kapatma
              ? 'Talep çavuşa/personele gönderilmeden kapatılır. Vatandaşa bildirim gitmez; uygulamada "Tamamlandı" görünür.'
              : 'Talep yeniden açılır. Varsa bölge çavuşu ve personel ataması kaldırılır; geçmiş iş akışında kalır.'}
          </p>
          <textarea
            className="talep-akisi-modal__not"
            placeholder="Açıklama (isteğe bağlı, iş akışına yazılır)"
            maxLength={1000}
            value={aciklama}
            onChange={(e) => setAciklama(e.target.value)}
          />
          {hata && <p className="error-message">{hata}</p>}
        </div>
        <div className="talep-akisi-modal__footer">
          <button type="button" className="talep-akisi-btn talep-akisi-btn--ikincil" onClick={onClose}>Vazgeç</button>
          <button type="button" className="talep-akisi-btn" onClick={onayla} disabled={gonderiliyor}>
            {gonderiliyor ? <Spinner size="small" /> : kapatma ? 'Sonuçlandır' : 'Yeniden Aç'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DurumDegistirModal;
